import {orangeColors} from '../../../../../layouts/theme/designSystem';

/** Only colors without an existing design-system token (see component-design-system-styles.mdc). */
export const selectableCardColors = {
  border: orangeColors[3],
  surface: orangeColors[7],
} as const;
